import Vapi from '@borisp/vuex-rest-api'
import { payloadToState, getOptimisticDelete } from 'utils/helpers'
import { VUE_APP_BASE_API_URL } from '@/constants/fileConstants'

export default new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    packages: [],
    packagesMetadata: {},
    package: {},
    packageMetadata: {}
  }
})
  .get({
    action: 'getPackages',
    property: 'packages',
    queryParams: true,
    path: '/packages/',
    onSuccess: payloadToState('packages')
  })
  .post({
    action: 'createPackage',
    property: 'package',
    path: '/packages/',
    onSuccess: payloadToState('package')
  })
  .get({
    action: 'getPackage',
    property: 'package',
    path: ({ id }) => `/packages/${id}`,
    onSuccess: payloadToState('package')
  })
  .put({
    action: 'updatePackage',
    property: 'package',
    path: ({ id }) => `/packages/${id}`,
    onSuccess: payloadToState('package')
  })
  .put({
    action: 'updatePackagePrices',
    property: 'package',
    path: ({ id }) => `/packages/${id}/updatePrices`,
    onSuccess: () => {}
  })
  .delete({
    action: 'deletePackage',
    property: 'package',
    path: ({ id }) => `/packages/${id}`,
    beforeRequest: getOptimisticDelete('packages'),
    onSuccess: payloadToState('package')
  })
  .delete({
    action: 'deleteVodPackage',
    property: 'package',
    path: ({ id }) => `/packages/${id}`,
    beforeRequest: getOptimisticDelete('packages'),
    onSuccess: payloadToState('package')
  })
  .getStore()
